import {InstallationViaQrCode as InstallationViaQrCodeType} from '@chekin/core';
import {InstallationSteps} from './components/InstallationSteps';
import {Alert, AlertDescription} from '@chekin/guestapp-ui-kit';
import {AlertCircle} from 'lucide-react';
import {useTranslation} from 'react-i18next';

type Props = {
  details: InstallationViaQrCodeType;
};
export const InstallationViaQrCode = ({details}: Props) => {
  const {t} = useTranslation();
  return (
    <div className="flex flex-col gap-6">
      <div className="flex gap-4 p-2 w-full bg-[var(--background-secondary)] rounded-lg items-start">
        <div className="shrink-0 p-1 bg-[var(--card)] rounded">
          <img
            src={details.qr_code_url}
            alt={details.qr_code_data}
            width={80}
            height={80}
          />
        </div>
        <div className="basis-40 grow">{t('esim.my.scan_qr_code_instruction')}</div>
      </div>
      <InstallationSteps steps={details.steps} />
      <Alert className="text-[var(--primary)] [--lucide-stroke-width:3]">
        <AlertCircle className="h-4 w-4" size={20} />
        <AlertDescription>{t('esim.my.qr_code_scanning_fallback')}</AlertDescription>
      </Alert>
    </div>
  );
};
